<template>
    <template v-if="componentData.workflowcardtype">
        <component
            v-if="componentData.workflowcardtype.data.workflowboard_id"
            :is="componentName"
            :simple="simple"
            :layout="layout"
            :workflowboard_id="componentData.workflowcardtype.data.workflowboard_id"
            :related_filter_json="componentData.related_filter_json"
        />
    </template>
</template>

<script>

import {defineComponent, onMounted, onUnmounted, reactive, inject, watch, computed, provide } from "vue";

// Components
import workflowphaseOverview from "view/dashboard/includes/workflowphase-overview";
import userOverview from "view/dashboard/includes/user-overview";

// Helpers
import trans from "helpers/_translation";
import {workflowcardtype} from "store/workflow";

import { env } from "config";

export default defineComponent({
    name: "workflowlayoutcard-overview",
    components: {
        userOverview,
        workflowphaseOverview
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    setup(props) {

        const viewData = inject("viewData");

        const componentData = reactive({
            workflowcardtype: computed(() => {
                if (!props.data.workflowcardtype_id) return null;
                return workflowcardtype(props.data.workflowcardtype_id);
            }),
            related_filter_json: computed(() => props.data.filter_json)
        });


        const customElementMap = env("custom_workflowlayoutcardoverview_mapping");
        const overruledSettings = computed(() => {
            return customElementMap.find(a => {
                return (`${a.workflowlayoutcardoverview_id}` === `${props.data.id}`) && (`${a.workflowboard_id}` === `${viewData.workflowboard_id}`);
            }) ?? null;
        });
        provide("overruledSettings",overruledSettings);
        const layout = computed(() => {
            return overruledSettings?.value?.layout ?? "tabular";
        });
        const simple = computed(() => {
            return overruledSettings?.value?.simple ?? true;
        });
        const componentName = computed(() => {
            return overruledSettings?.value?.component ?? "workflowphaseOverview";
        })

        return {
            trans,

            viewData,
            componentData,

            layout,
            simple,
            componentName
        };
    },
});

</script>